import { Component, SimpleChanges, OnDestroy, Output, Input, EventEmitter, OnInit } from '@angular/core';

import { MsalService, MsalBroadcastService } from '@azure/msal-angular';
import { AJWebService } from '../services/ajWeb.service';
import * as jwt_decode from "jwt-decode";
import { NgxSpinnerService } from "ngx-spinner";

declare var bootbox: any;

import { timeMonths } from 'd3';
import { ActivatedRoute, Router } from '@angular/router';
import { AppConfigService } from 'src/services/app-config.service';
import { InteractionStatus } from '@azure/msal-browser';
import { filter, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';



declare var userNotification: any;



@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy {
  private readonly _destroying$ = new Subject<void>();

  //private subscription: Subscription;
  public environmentDetails: any;

  public isIframe: boolean;


  public DefaultDS: string;
  public SelectedDeliveryStructureId: string;
  public selectedDCUId: string;
  public DSCollapsed: boolean = true;
  public apRedirectURL: any;
  public showScopeSelector: string = "";
  public clickedonheadervalues: boolean = true;
  public DefaultDSId: string;
  public IsSelected: boolean = true;
  public IsScopeChange: boolean = false;
  public more: boolean[] = [];
  public more1: boolean[] = [];
  public payload_token:any;
  public token:any;
  public MSALenabled = true;
  public scopr_title: string;
  E2E: string;
  data:any;
  userlist: any=[];
  loginDisplay: any;

  constructor(public ajWebService: AJWebService, private broadcastService: MsalBroadcastService, private authMSALService: MsalService, private SpinnerService: NgxSpinnerService, private route: Router, private activatedRoute: ActivatedRoute, private appConfig: AppConfigService) {
    //this.isIframe = window !== window.parent && !window.opener;


  }
  isLoggedIn(): boolean {

    return this.authMSALService.instance.getActiveAccount() != null
  }


  ngOnInit(): void {
    this.E2E = window.location.href.split("/").pop();
    sessionStorage.setItem("E2E",this.E2E);
  
    this.MSALLogin(); //MSAL login code
    //this.GetScopeandOpp(); //SAAS get scope and pass to OPP local

  }
  setLoginDisplay() {
    this.loginDisplay = this.authMSALService.instance.getAllAccounts().length > 0;
  }

  checkAndSetActiveAccount(){
    /**
     * If no active account set but there are accounts signed in, sets first account to active account
     * To use active account set here, subscribe to inProgress$ first in your component
     * Note: Basic usage demonstrated. Your app may require more complicated account selection logic
     */
    let activeAccount = this.authMSALService.instance.getActiveAccount();

    if (!activeAccount && this.authMSALService.instance.getAllAccounts().length > 0) {
      let accounts = this.authMSALService.instance.getAllAccounts();
      this.authMSALService.instance.setActiveAccount(accounts[0]);
    }
  }

  MSALLogin(){
    if (this.MSALenabled == true) {
      if (!this.isLoggedIn()) {
        //this.authMSALService.handleRedirectObservable
        this.authMSALService.instance.loginRedirect();
        this.authMSALService.instance.handleRedirectPromise().then(res => {
          if (res == null) {
            let data = this.route.url;
            sessionStorage.setItem('navurl', location.href);
        }
          if (res != null && res.account != null) {

            this.authMSALService.instance.setActiveAccount(res.account);
            const id_token = res.idToken;
            const access_token = res.accessToken;
            sessionStorage.setItem('token', JSON.stringify(id_token));
            this.payload_token = this.getDecodedAccessToken(id_token); // decodeing tokan here
            sessionStorage.setItem('userId', this.payload_token.preferred_username);
            this.ajWebService.enterpriseId = res.account.username.split('@')[0];
            localStorage.setItem('msal.idtoken', JSON.stringify(id_token));
            if (localStorage.getItem('msal.idtoken') != undefined && localStorage.getItem('msal.idtoken') != '')
              {
                this.ajWebService.showConfidentialityMessage('You are using an Accenture proprietary tool ("myWizard"). You understand that this tool may contain  <strong>ACCENTURE, CLIENT, OR VENDOR / PARTNER CONFIDENTIAL INFORMATION</strong>. You are obligated to adhere to applicable confidentiality obligations and Accenture’s policies, including Policy 69 – Confidentiality, when using the tool and information in the tool.  Information in the tool can only be shared with those authorized to receive it. If you are downloading/exporting Confidential Information to another file or report, you must label that file or report as Accenture Confidential. If you have any questions, please email your question to <a href="mailto:confidentiality@accenture.com?cc=AutomationJourney_Dev@accenture.com&subject=Confidential Information Query (Asset: myWizard)&body=Hi, %0A%0AI have the below query, could you please help on this %0A%0A[TYPE YOUR QUERY HERE]">confidentiality@accenture.com</a> or contact your Leadership. Thank you!');
              if (sessionStorage.getItem('navurl') != undefined || sessionStorage.getItem('navurl') != null) {
                var data = sessionStorage.getItem('navurl').toString();
                //sessionStorage.removeItem("navurl");
                //window.location.href = data;//"https://mywizard-aiprojectmanager.ciostage.accenture.com" + data;
                //this.GetScopeandOpp()
            }

          }
            else {
              console.log('*****id_token check id_token!=undefined && id_token************');
            }
          }
          else{
            //this.authMSALService.instance.loginRedirect();
          }
        }).catch(error => {
          console.log("catch block error");
        });
      }
      else {
        console.log('*****User Already login************');
        if (localStorage.getItem('msal.idtoken') != undefined && localStorage.getItem('msal.idtoken') != '')
          this.ajWebService.showConfidentialityMessage('You are using an Accenture proprietary tool ("myWizard"). You understand that this tool may contain  <strong>ACCENTURE, CLIENT, OR VENDOR / PARTNER CONFIDENTIAL INFORMATION</strong>. You are obligated to adhere to applicable confidentiality obligations and Accenture’s policies, including Policy 69 – Confidentiality, when using the tool and information in the tool.  Information in the tool can only be shared with those authorized to receive it. If you are downloading/exporting Confidential Information to another file or report, you must label that file or report as Accenture Confidential. If you have any questions, please email your question to <a href="mailto:confidentiality@accenture.com?cc=AutomationJourney_Dev@accenture.com&subject=Confidential Information Query (Asset: myWizard)&body=Hi, %0A%0AI have the below query, could you please help on this %0A%0A[TYPE YOUR QUERY HERE]">confidentiality@accenture.com</a> or contact your Leadership. Thank you!');

        this.token = localStorage.getItem("msal.idtoken");
        if (sessionStorage.getItem('navurl') != undefined || sessionStorage.getItem('navurl') != null) {
          var data = sessionStorage.getItem('navurl').toString();
          sessionStorage.removeItem("navurl");
          window.location.href = data;//"https://mywizard-aiprojectmanager.ciostage.accenture.com" + data;
          //this.GetScopeandOpp()
      }
        this.payload_token = this.getDecodedAccessToken(this.token);
        this.GetScopeandOpp()
        this.ajWebService.enterpriseId = this.payload_token.preferred_username.split('@')[0];
      }
    }
    else {
      this.ajWebService.enterpriseId = 'AJdev';
    }
  }

  GetScopeandOpp(){
    //this.ajWebService.enterpriseId = 'sanraj.malik';
    var queryString = window.location.href.split('/');
    // var queryStringObj = window.location.search;
    // if (queryStringObj != null && queryStringObj != "") {
    //   var urlParams = new URLSearchParams(window.location.search);
    //   this.ajWebService.EndToEndUId = urlParams.get("Client");
    //   this.SelectedDeliveryStructureId = urlParams.get("DS");
    //   this.selectedDCUId = urlParams.get("DC");
    //   this.IsScopeChange = true;

    // }
    if (queryString.findIndex(element => element.includes("home"))!=-1) {
      this.E2E = sessionStorage.getItem("E2E");
      //this.E2E = window.location.href.split("/").pop();
          //this.ajWebService.showConfidentialityMessage('You are using an Accenture proprietary tool ("myWizard"). You understand that this tool may contain  <strong>ACCENTURE, CLIENT, OR VENDOR / PARTNER CONFIDENTIAL INFORMATION</strong>. You are obligated to adhere to applicable confidentiality obligations and Accenture’s policies, including Policy 69 – Confidentiality, when using the tool and information in the tool.  Information in the tool can only be shared with those authorized to receive it. If you are downloading/exporting Confidential Information to another file or report, you must label that file or report as Accenture Confidential. If you have any questions, please email your question to <a href="mailto:confidentiality@accenture.com?cc=AutomationJourney_Dev@accenture.com&subject=Confidential Information Query (Asset: myWizard)&body=Hi, %0A%0AI have the below query, could you please help on this %0A%0A[TYPE YOUR QUERY HERE]">confidentiality@accenture.com</a> or contact your Leadership. Thank you!');
          this.ajWebService.AppSettings().subscribe(AppSettingsResponse => {
            this.SpinnerService.show();
            if (AppSettingsResponse != null) {
              this.ajWebService.appSettingResponse = AppSettingsResponse as any;
              this.ajWebService.ExternalURLs = (this.ajWebService.appSettingResponse as any).filter(x => x.Category == "ExternalURLs");
              this.ajWebService.ClientDeliveryStructure = (this.ajWebService.appSettingResponse as any).filter(x => x.Category == "ClientDeliveryStructure");
              this.ajWebService.clientName = this.ajWebService.ClientDeliveryStructure.find(x => x.ConfigurationKey == "clientName").ConfigurationValue;
              this.ajWebService.EndToEndUId = this.ajWebService.ClientDeliveryStructure.find(x => x.ConfigurationKey == "EndToEndUId").ConfigurationValue;
              this.ajWebService.AJBaseURL = this.ajWebService.ExternalURLs.find(x => x.ConfigurationKey == "AJ").ConfigurationValue;
              //this.ajWebService.GetScopeDetails(this.E2E);
            }
          },
            error => {
              this.SpinnerService.hide();
              console.log(error)
            });

    }
  }

  BindScopeValues(DeliveryStructures, SelectedDeliveryStructure, SelectedDeliveryConstruct) {

    if (DeliveryStructures != null) {
      DeliveryStructures.forEach((DS, key) => {
        if (DS.id == SelectedDeliveryStructure) {
          this.ajWebService.selectedAssociatedDCIdIOM = "";
          this.ajWebService.scopeselectedlevelTemp[1].Text = DS.name + " | ";
          this.ajWebService.scopeselectedlevelTemp[1].URL = this.ajWebService.AJBaseURL + "?Client=" + this.ajWebService.EndToEndUId + "&DS=" + DS.id;
        }
        else if (DS.id == SelectedDeliveryConstruct) {
          this.ajWebService.scopeselectedlevelTemp[3].Text = DS.name;
          this.ajWebService.scopeselectedlevelTemp[3].URL = this.ajWebService.AJBaseURL + "?Client=" + this.ajWebService.EndToEndUId + "&DS=" + SelectedDeliveryStructure + "&DC=" + SelectedDeliveryConstruct;

          if (DS.parentId != "" && DS.parentId != null) {
            this.ajWebService.selectedAssociatedDCIdIOM = DS.parentId;
            this.ajWebService.scopeselectedlevelTemp[2].URL = this.ajWebService.AJBaseURL + "?Client=" + this.ajWebService.EndToEndUId + "&DS=" + SelectedDeliveryStructure + "&DC=" + DS.parentId;;
            this.ajWebService.scopeselectedlevelTemp[2].Text = DS.parentName + " | ";
          }
          else {
            this.ajWebService.selectedAssociatedDCIdIOM = "";
            this.ajWebService.scopeselectedlevelTemp[2].URL = "";
            this.ajWebService.scopeselectedlevelTemp[2].Text = "";
          }
        }

        this.BindScopeValues(DS.DeliveryConstructs, SelectedDeliveryStructure, SelectedDeliveryConstruct);
      })
    }
  }


  LoadDeliveryConstructs(SelectedDeliveryStructureId: any, SelectedDeliveryConstructId: any) {

    this.SelectedDeliveryStructureId = SelectedDeliveryStructureId;
    this.selectedDCUId = SelectedDeliveryConstructId;
    if (SelectedDeliveryConstructId == undefined) {
      this.ajWebService.SelectedDeliveryConstructId = null;
    } else {
      this.ajWebService.SelectedDeliveryConstructId = SelectedDeliveryConstructId;
    }


    if (this.ajWebService.clientName != null && this.ajWebService.clientName != undefined)
      this.ajWebService.ScopeSelectorValueTemp = this.ajWebService.clientName;
    else
      this.ajWebService.ScopeSelectorValueTemp = "";
    this.ResetValueToOriginal(this.ajWebService.DeliveryStructures, SelectedDeliveryStructureId, SelectedDeliveryConstructId);
    this.ajWebService.SelectedDC = [];



    this.ajWebService.SelectedDeliveryStructure = [];
    if (SelectedDeliveryStructureId && SelectedDeliveryConstructId && SelectedDeliveryConstructId != null && SelectedDeliveryConstructId != 'null') {
      this.ajWebService.SelectedDeliveryStructure.push(this.ajWebService.DeliveryStructures.find(x => x.id == SelectedDeliveryStructureId));
      if (this.ajWebService.DeliveryStructures.find(x => x.id == SelectedDeliveryStructureId) != "" && this.ajWebService.DeliveryStructures.find(x => x.id == SelectedDeliveryStructureId) != null)
        this.GetSelectedDeliveryConstructObject(this.ajWebService.DeliveryStructures.find(x => x.id == SelectedDeliveryStructureId).DeliveryConstructs, this.selectedDCUId);
      this.DefaultDS = this.ajWebService.DeliveryStructures.find(x => x.id == SelectedDeliveryStructureId);
    }
    else if (SelectedDeliveryStructureId && (SelectedDeliveryConstructId == null || (SelectedDeliveryConstructId != null && SelectedDeliveryConstructId == ""))) {
      //$rootScope.DeliveryStructures.find(x => x.id == SelectedDeliveryStructureId).isSelected = true;
      this.ajWebService.SelectedDeliveryStructure.push(this.ajWebService.DeliveryStructures.find(x => x.id == SelectedDeliveryStructureId));
      this.ajWebService.SelectedDC.push({
        id: SelectedDeliveryStructureId,
        name: "DS",
        parentId: this.ajWebService.EndToEndUId,
        deliveryStructureId: SelectedDeliveryStructureId
      });
      //$rootScope.SelectedDC.push($rootScope.DeliveryStructures.find(x => x.id == SelectedDeliveryStructureId));
      this.DefaultDS = this.ajWebService.DeliveryStructures.find(x => x.id == SelectedDeliveryStructureId);
    }
    else {
      //Client level - By Default

      this.ajWebService.SelectedDC.push({
        id: this.ajWebService.EndToEndUId,
        name: "Client",
        parentId: null,
        deliveryStructureId: null
      });
      this.ajWebService.SelectedDeliveryStructure.push(this.ajWebService.DeliveryStructures[0]);
      //$rootScope.SelectedDC.push($rootScope.DeliveryStructures[0]);
      this.DefaultDS = this.ajWebService.DeliveryStructures[0];
      //console.log(this.ajWebService.SelectedDeliveryStructure);

    }

  }

  SelectItem(id) {

    var select = $("[id^='ScopeSelector']")
    select.css({
      background: ""
    });
    if (id != "")
      document.getElementById('ScopeSelector' + id).style.backgroundColor = 'lightskyblue';
  };


  ResetValueToOriginal(DeliveryStructures: any, SelectedDeliveryStructure: any, SelectedDeliveryConstruct: any) {

    if (DeliveryStructures != null) {
      DeliveryStructures.forEach((DS, key) => {
        if (DS.id == SelectedDeliveryStructure) {
          DS.isSelected = true;
          this.SelectedDeliveryStructureId = SelectedDeliveryStructure;

        }
        else if (DS.id == SelectedDeliveryConstruct) {
          DS.isSelected = true;
          this.selectedDCUId = SelectedDeliveryConstruct;
        }
        else {
          DS.isSelected = false;
        }
        this.ResetValueToOriginal(DS.DeliveryConstructs, SelectedDeliveryStructure, SelectedDeliveryConstruct);

      })
    }
  }
  GetSelectedDeliveryConstructObject(currectCollection, selectedDCId) {
    if (currectCollection != null) {
      for (var i = 0; i < currectCollection.length; i++) {
        if (currectCollection[i].id == selectedDCId) {
          var result = currectCollection.find(x => x.id == selectedDCId);
          this.ajWebService.SelectedDC.push(result);

        }
        else {
          if (currectCollection[i].DeliveryConstructs != null) {
            if (this.ajWebService.clientName != "" && this.ajWebService.clientName != null && selectedDCId != "" && selectedDCId != null) {
              if ($('#span' + selectedDCId).hasClass("selectedDeliveryConstruct"))
                $('#span' + selectedDCId).removeClass('selectedDeliveryConstruct');

            }
            this.GetSelectedDeliveryConstructObject(currectCollection[i].DeliveryConstructs, selectedDCId);
          }
        }
      }

    }
  }

  Apply() {

    this.ajWebService.scopeselectedlevelTemp = [{ URL: this.ajWebService.AJBaseURL, Text: this.ajWebService.clientName + " | ", Level: "Client" }, { URL: "", Text: "", Level: "DS" }, { URL: "", Text: "", Level: "ADC" }, { URL: "", Text: "", Level: "DC" }];
    this.LoadDeliveryConstructs(this.SelectedDeliveryStructureId, this.selectedDCUId);
    // $rootScope.LoadOpportunity(); check
    this.BindScopeValues(this.ajWebService.DeliveryStructures, this.SelectedDeliveryStructureId, this.selectedDCUId);
    this.ajWebService.scopeselectedlevel = this.ajWebService.scopeselectedlevelTemp;
    this.ajWebService.setScope(this.ajWebService.SelectedDC);
    //AJ-> AP
    this.ajWebService.apRedirectURL = this.ajWebService.environmentDetails.apHomeUrl;
    if (this.SelectedDeliveryStructureId == "" || this.SelectedDeliveryStructureId == undefined || this.SelectedDeliveryStructureId == null)
      this.ajWebService.apRedirectURL = this.ajWebService.apRedirectURL + "/null";
    else
      this.ajWebService.apRedirectURL = this.ajWebService.apRedirectURL + "/" + this.SelectedDeliveryStructureId;
    if (this.selectedDCUId == "" || this.selectedDCUId == undefined || this.selectedDCUId == null)
      this.ajWebService.apRedirectURL = this.ajWebService.apRedirectURL + "/null";
    else
      this.ajWebService.apRedirectURL = this.ajWebService.apRedirectURL + "/" + this.selectedDCUId;
    this.ajWebService.apRedirectURL = this.ajWebService.apRedirectURL + "/5";


    //End AJ-AP

    //IOM Redirect AJ-IOM
    this.ajWebService.IOMRedirectUrl = this.ajWebService.environmentDetails.aiaaHomeUrl;
    if (this.SelectedDeliveryStructureId == "" || this.SelectedDeliveryStructureId == undefined || this.SelectedDeliveryStructureId == null)
      this.ajWebService.IOMRedirectUrl = this.ajWebService.environmentDetails.aiaaHomeUrl + "/?ClientUId=" + this.ajWebService.EndToEndUId + "&AssociatedDeliveryConstructUId=&DeliveryConstructUId=" + this.ajWebService.EndToEndUId;
    else if (this.selectedDCUId != "" && this.selectedDCUId != null && this.SelectedDeliveryStructureId != "" && this.SelectedDeliveryStructureId != null) {
      if (this.ajWebService.selectedAssociatedDCIdIOM != "") {
        this.ajWebService.IOMRedirectUrl = this.ajWebService.environmentDetails.aiaaHomeUrl + "/?ClientUId=" + this.SelectedDeliveryStructureId + "&AssociatedDeliveryConstructUId=" + this.ajWebService.selectedAssociatedDCIdIOM + "&DeliveryConstructUId=" + this.selectedDCUId;
      }
      else
        this.ajWebService.IOMRedirectUrl = this.ajWebService.environmentDetails.aiaaHomeUrl + "/?ClientUId=" + this.SelectedDeliveryStructureId + "&AssociatedDeliveryConstructUId=" + this.SelectedDeliveryStructureId + "&DeliveryConstructUId=" + this.selectedDCUId;
    }
    else if (this.SelectedDeliveryStructureId != "" && this.SelectedDeliveryStructureId != null) {
      this.ajWebService.IOMRedirectUrl = this.ajWebService.environmentDetails.aiaaHomeUrl + "/?ClientUId=" + this.SelectedDeliveryStructureId + "&AssociatedDeliveryConstructUId=&DeliveryConstructUId=" + this.SelectedDeliveryStructureId;
    }

    //End AJ-IOM
    if (this.ajWebService.scopeselectedlevel[0].Text.length > 1 && this.ajWebService.scopeselectedlevel[0].Text != undefined) {
      this.scopr_title = "";
      this.scopr_title = this.ajWebService.scopeselectedlevel[0].Text;
    }
    if (this.ajWebService.scopeselectedlevel[1].Text.length > 1 && this.ajWebService.scopeselectedlevel[1].Text != undefined) {
      this.scopr_title = "";
      this.scopr_title = this.ajWebService.scopeselectedlevel[0].Text + this.ajWebService.scopeselectedlevel[1].Text;
    }
    if (this.ajWebService.scopeselectedlevel[2].Text.length > 1 && this.ajWebService.scopeselectedlevel[2].Text != undefined) {
      this.scopr_title = "";
      this.scopr_title = this.ajWebService.scopeselectedlevel[0].Text + this.ajWebService.scopeselectedlevel[1].Text + this.ajWebService.scopeselectedlevel[2].Text;
    }
    if (this.ajWebService.scopeselectedlevel[3].Text.length > 1 && this.ajWebService.scopeselectedlevel[3].Text != undefined) {
      this.scopr_title = "";
      this.scopr_title = this.ajWebService.scopeselectedlevel[0].Text + this.ajWebService.scopeselectedlevel[1].Text + this.ajWebService.scopeselectedlevel[2].Text + this.ajWebService.scopeselectedlevel[3].Text;;
    }



  }

  closeScopeSelectorApply(clicked: boolean) {
    $(".form-control.form-control-sm").val("");
    this.showScopeSelector = "";
  }

  closeScopeSelector(clicked: boolean) {
    clicked == true ? this.clickedonheadervalues = false : this.showScopeSelector = "";

  }

  toggleScopeSelector() {
    this.showScopeSelector == '' ? this.showScopeSelector = 'show' : this.showScopeSelector = '';
    this.clickedonheadervalues = true;

  }

  Redirectscope(url) {
    var decodedUrl = decodeURIComponent(url);
    window.location.replace(decodedUrl);
  }


  logOutUser() {
    // this.ajWebService.ClearCookie().subscribe(response => {
    //   if (response != null) {
    //     this.ajWebService.ClearApiCache().subscribe(response => {
    //       var location = window.location.host;
    //       console.log(location);
    //       var url = 'https://' + location + '/atr-gateway/identity-management/api/v1/auth/logout';
    //       this.ajWebService.ATRLogOut(url).subscribe(ATRresponse => {
    //         console.log("ATRresponse", ATRresponse);
    //         window.location.replace(this.ajWebService.ExternalURLs.find(x => x.ConfigurationKey == "Logout").ConfigurationValue);
    //       },
    //         error => {
    //           console.log(error);
    //           //window.location.replace(this.ajWebService.ExternalURLs.find(x => x.ConfigurationKey == "Logout").ConfigurationValue);
    //         });
    //     },
    //       error => {
    //         console.log(error)
    //       });
    //   }
    // },
    //   error => {
    //     console.log(error)
    //   });

    // this.environmentDetails = this.appConfig.environmentSettings;
    sessionStorage.clear();
    localStorage.clear();
    this.authMSALService.logout();
  }


  getDecodedAccessToken(token: string): any {
    try {
      return jwt_decode(token);
    } catch (e) {
      console.log(e);
      return null;

    }
  }


  scopedetailsfutureref(){
                  // this.ajWebService.GetSaasProvision(this.E2E).subscribe((data) => {
              //   this.ajWebService.SaasDetails = data;
              //   if (this.ajWebService.SaasDetails.length > 0) {
              //     // if (
              //     //   this.ajWebService.enterpriseId == this.ajWebService.SaasDetails[0].RequestorID
              //     // ) {
              //       this.scopr_title =
              //       this.ajWebService.SaasDetails[0].ClientName + ' | ' + this.ajWebService.SaasDetails[0].E2EName;
              //       this.ajWebService.SelectedDC.push({
              //         id: this.ajWebService.SaasDetails[0].E2EUID,
              //         name: 'DS',
              //         parentId: null,
              //         deliveryStructureId: this.ajWebService.SaasDetails[0].E2EUID,
              //       });
              //       this.ajWebService.GetSaaSUsers(this.E2E).subscribe(userlist=>{
              //         this.userlist=userlist;
              //         this.userlist = this.userlist.map(obj => obj.RequestorID);
              //         const found = this.userlist.find(x=>x==this.ajWebService.enterpriseId);
              //           if (this.ajWebService.enterpriseId == found) {
              //             this.ajWebService.setScope(this.ajWebService.SelectedDC);
              //           } else {
              //             this.route.navigateByUrl('/error');
              //           }
              //       })
                    
              //   } else {
              //     this.route.navigateByUrl('/error');
              //   }
              // },err=>{
              //   console.log(err)
              // });
  }
  ngOnDestroy(): void {
    // this._destroying$.next(undefined);
    // this._destroying$.complete();
  }

}
